__webpack_require__.p = "/tr_TR/";